// extracted by mini-css-extract-plugin
export default {"container":"AlternativeNav_container__WupdF","title":"AlternativeNav_title__GrYpz"};